export const UserAccountActions = Object.freeze({
  USER_ACCOUNT_UPDATE_ACCOUNT: 'USER_ACCOUNT_UPDATE_ACCOUNT',
  USER_ACCOUNT_CLEAR_PASSWORD_FORM: 'USER_ACCOUNT_CLEAR_PASSWORD_FORM',
  USER_ACCOUNT_CLEAR_SUCCESS_MESSAGE: 'USER_ACCOUNT_CLEAR_SUCCESS_MESSAGE',
  USER_ACCOUNT_UPDATE_CONTENT_SETTINGS: 'USER_ACCOUNT_UPDATE_CONTENT_SETTINGS',
  USER_ACCOUNT_IS_EDITING: 'USER_ACCOUNT_IS_EDITING',
  SET_GENDER: 'SET_GENDER',
  CLEAR_ERROR_KEY: 'USER_ACCOUNT_CLEAR_ERROR_KEY',
  CLEAR_DELETE_LISTENER_ERROR: 'CLEAR_DELETE_LISTENER_ERROR',
  CLEAR_LOG_OUT_ALL_DEVICES_ERROR: 'CLEAR_LOG_OUT_ALL_DEVICES_ERROR',
  RESET_LOG_OUT_ALL_DEVICES: 'RESET_LOG_OUT_ALL_DEVICES',
} as const);

export const CLEAR_SUCCESS_MESSAGE_DELAY = 3000;
